export default __webpack_public_path__ + "static/media/no_result.b3248c0a.svg";